export default "__VITE_ASSET__ZXayxSRk__"